import { render, staticRenderFns } from "./CommutatorReferenceField.vue?vue&type=template&id=d5f76a9e&scoped=true&"
import script from "./CommutatorReferenceField.vue?vue&type=script&lang=js&"
export * from "./CommutatorReferenceField.vue?vue&type=script&lang=js&"
import style0 from "./CommutatorReferenceField.vue?vue&type=style&index=0&id=d5f76a9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f76a9e",
  null
  
)

export default component.exports